/*IMAGENES*/


import { API_URL } from '../Config.js';

const apiUrl = API_URL 


const imagenes = []

const getImages = (id) => {
    return new Promise((resolve, reject) => {
        const image = imagenes.find((i) => i.id === parseInt(id));
        setTimeout(() => {
            if (image) {
                resolve(image);
            }
            else { reject("No se encontró la imagen.") }

        }, 1000);
    });
};


/*
const getImageList = () => {
    return new Promise((resolve, reject) => {

        setTimeout(() => {
            if (imagenes) {
                resolve(imagenes);
            } else {
                reject("No se encontraron imagenes.")
            }
        }, 5000);
    });
};
*/

const getImageList = ( accessToken ) => {

    const headers = {
        Authorization: `Bearer ${accessToken}`
    }

    /*const url = `${API_URL}formularios/frmGetGrillaImg`*/
    const url = `${apiUrl}formularios/frmGetGrillaImg`

    return fetch(url, { headers })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(error => console.log('Error:', error));
};


const addImage = (data, accessToken) => {

    const url = `${apiUrl}formularios/frmImgInsert`

    return fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` } })
        .then(response => { return response.json() })
        //.then(data => {return data})
        .catch(error => { });

}

const frmDelImg = (data, accessToken) => {

    const url = `${apiUrl}formularios/frmDelImg`

    return fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` } })
        .then(response => { return response.json() })
        //.then(data => {return data})
        .catch(error => { });

}

const frmDelFirma = (data, accessToken) => {

    const url = `${apiUrl}formularios/frmDelFirma` 

    return fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` } })
        .then(response => { 
            return;
        })
        .catch(
            error => { 
                
            }); 

}

const getPosicionImgList = ( accessToken ) => {

    const headers = {
        Authorization: `Bearer ${accessToken}`
    }

    /*const url = `${API_URL}formularios/frmGetGrillaImg`*/
    const url = `${apiUrl}formularios/frmGetImgPosicion`

    return fetch(url, { headers })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(error => console.log('Error:', error));
};

const getImageTipoList = ( accessToken, Tipo ) => {

    const headers = {
        Authorization: `Bearer ${accessToken}`
    }

    /*const url = `${API_URL}formularios/frmGetGrillaImg`*/
    const url = `${apiUrl}formularios/frmGetGrillaImg`

    return fetch(url, { headers })
        .then(response => response.json())
        .then(data => { 
            const datos = data.filter((d) => d.Tipo ===Tipo)
            return datos; })
        .catch(error => console.log('Error:', error));
};

const getPosicionFirmaList = ( accessToken ) => {

    const headers = {
        Authorization: `Bearer ${accessToken}`
    }

    const url = `${apiUrl}formularios/frmGetFirmasPosicion`

    return fetch(url, { headers })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(error => console.log('Error:', error));
};


//export default getImageList;

export { getImageList, getImages, addImage, getPosicionImgList, getImageTipoList, getPosicionFirmaList, frmDelImg, frmDelFirma }